<template>
  <div class="look-up">
    <div class="search-warehouse">
      <div class="screen">
        <el-input class="white w200" v-model="screen.name" placeholder="请输入抬头名称"></el-input>
        <el-input class="white w200" v-model="screen.code" placeholder="请输入编码"></el-input>
        <el-select class="white w200" clearable v-model="screen.isOpen" placeholder="请选择">
          <el-option
            v-for="item in isOpenList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button class="btn-blue" @click="onScreen">搜索</el-button>
      </div>
      <div class="add">
        <el-button class="btn-blue" @click="add">+新增</el-button>
      </div>
    </div>

    <DropTable
      :columns="tableTitleList"
      :data="copingWithHeaderList"
      tableKey="CategoriesList"
      :row-class-name="tableRowClassName"
      border
    >
      <template slot="action" slot-scope="scope">
        <el-button :disabled="!scope.row.status" class="btn-text mod-btn" type="text"
          @click="mod(scope.row)">编辑</el-button>
        <el-button v-if="!scope.row.status" class="btn-text" type="text" @click="open(scope.row)">开启</el-button>
        <el-button v-else class="btn-text" type="text" @click="close(scope.row)">关闭</el-button>
        <el-button class="btn-red" type="text"
          @click="del(scope.row)">刪除</el-button>
      </template>
    </DropTable>

    <!-- 新增/编辑 -->
    <el-dialog :title="lookUpForm.id ? '编辑' : '新增'" top="17vh" :visible.sync="lookUpDialog" width="420px">
      <div class="border"></div>
      <el-form ref="lookUpForm" :model="lookUpForm" :rules="lookUpRules">
        <el-form-item label="抬头名称" prop="name">
          <el-input v-model="lookUpForm.name" class="white" placeholder="请输入抬头名称"></el-input>
        </el-form-item>
        <el-form-item label="开户银行" prop="bankName">
          <el-input v-model="lookUpForm.bankName" class="white" placeholder="请输入开户银行"></el-input>
        </el-form-item>
        <el-form-item label="开户账号" prop="bankAccount">
          <el-input v-model="lookUpForm.bankAccount" class="white" placeholder="请输入开户账号"></el-input>
        </el-form-item>
        <el-form-item label="税号" prop="taxNumber">
          <el-input v-model="lookUpForm.taxNumber" class="white" placeholder="请输入税号"></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="code">
          <el-input v-model="lookUpForm.code" class="white" placeholder="请输入编码"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeLookUpDialog">取消</el-button>
        <el-button class="btn-blue" @click="saveLookUp('lookUpForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LookUp from "models/look-up";
import LookUpMixins from "common/mixins/look-up.js";
import { modifyNetTitle } from "common/js/util";
import DropTable from "components/base/DropTable.vue";
export default {
  mixins: [LookUpMixins],
  components: {
    DropTable
  },
  data() {
    return {
      tableData: [],
      tableTitleList: [
        { checked: true, label: '序号', prop: 'sort', "width": '70', fixed: "left",},
        { checked: true, label: '抬头名称', prop: 'name'},
        { checked: true, label: '编码', prop: 'code' },
        { checked: true, label: '开户银行', prop: 'bankName' },
        { checked: true, label: '开户账号', prop: 'bankAccount' },
        { checked: true, label: '税号', prop: 'taxNumber'},
        { 
          checked: true, 
          label: "操作", 
          prop: "action", 
          fixed: "right", 
          "width": "150",
          slotName: "action", // 自定义单元格插槽
          // disabled: true
        }
      ],
      lookUpDialog: false,
      lookUpForm: {
        id: '',
        name: '',
        bankName: '',
        bankAccount: '',
        taxNumber: '',
        code: ''
      },
      lookUpRules: {
        name: [{ required: true, message: "请输入抬头名称", trigger: "blur" }],
        bankName: [{ required: true, message: "请输入开户银行", trigger: "blur" }],
        bankAccount: [{ required: true, message: "请输入开户账号", trigger: "blur" }],
        taxNumber: [{ required: true, message: "请输入税号", trigger: "blur" }],
        code: [{ required: true, message: "请输入编码", trigger: "blur" }],
      },
    };
  },
  created() {
    modifyNetTitle('进出仓应付抬头')
    this.initCopingWithHeaderList();
  },
  methods: {
    tableRowClassName({ row }) {
      if (!row.status) {
        return "close-row";
      }
    },
    onScreen() {
      this.initCopingWithHeaderList();
    },
    //新增
    add() {
      this.lookUpDialog = true;
    },
    closeLookUpDialog() {
      this.lookUpForm.name = ''
      this.lookUpForm.bankName = ''
      this.lookUpForm.bankAccount = ''
      this.lookUpForm.taxNumber = ''
      this.lookUpForm.code = ''
      this.lookUpForm.id = ''
      this.lookUpDialog = false;
    },
    saveLookUp(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.lookUpForm.id) {
            let data = {};
            data.id = this.lookUpForm.id;
            data.name = this.lookUpForm.name;
            data.bankName = this.lookUpForm.bankName;
            data.bankAccount = this.lookUpForm.bankAccount;
            data.taxNumber = this.lookUpForm.taxNumber;
            data.code = this.lookUpForm.code;
            LookUp.postUpdateCopingWithHeader(this.lookUpForm.id, data).then(res => {
              if (res.success) {
                this.initCopingWithHeaderList();
                this.$message.success("修改成功");
                this.closeLookUpDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let data = {};
            data.name = this.lookUpForm.name;
            data.bankName = this.lookUpForm.bankName;
            data.bankAccount = this.lookUpForm.bankAccount;
            data.taxNumber = this.lookUpForm.taxNumber;
            data.code = this.lookUpForm.code;
            LookUp.postAddCopingWithHeader(data).then(res => {
              if (res.success) {
                this.initCopingWithHeaderList();
                this.$message.success("新增成功");
                this.closeLookUpDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    mod(row) {
      this.lookUpForm.name = row.name
      this.lookUpForm.id = row.id
      this.lookUpForm.bankName = row.bankName
      this.lookUpForm.bankAccount = row.bankAccount
      this.lookUpForm.taxNumber = row.taxNumber
      this.lookUpForm.code = row.code
      this.add()
    },
    open(row) {
      this.$confirm("是否开启该抬头？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white'
      })
        .then(() => {
          this.commonFun(row)
        })
        .catch(() => {});
    },
    close(row) {
      this.$confirm("是否关闭该抬头？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white'
      })
        .then(() => {
          this.commonFun(row)
        })
        .catch(() => {});
    },
    del(row) {
      this.$confirm("是否刪除该抬头？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white'
      })
        .then(() => {
          LookUp.postDelCopingWithHeader(row.id).then(res => {
            if (res.success) {
              this.initCopingWithHeaderList();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },
    commonFun(row) {
      LookUp.postUpdateCopingWithHeaderStatus(row.id).then(res => {
        if (res.success) {
          this.initCopingWithHeaderList();
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.look-up {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .search-warehouse {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .screen {
      display: flex;
      .w200 {
        width: 200px;
        margin-right: 16px;
      }
    }
  }
  .table .el-table .el-table__body-wrapper .el-table__body .close-row td .cell {
    color: #999999;
    font-family: 'PingFang SC-Regular';
    .el-button.mod-btn {
      color: #999999;
      font-size: 14px;
    }
  }
  .el-button.btn-red {
    color: #F56C6C;
  }
  
  .el-dialog {
    .el-dialog__header {
      padding-left: 20px;
    }
    .el-dialog__body {
      padding: 0px;
      .el-form {
        padding: 20px;
        .el-form-item {
          .el-form-item__label {
            width: 100%;
            height: 28px;
            line-height: 24px;
            text-align: left;
          }
          .el-form-item__content {
            width: 100%;
          }
        }
      }
      .border {
        border-color: #EEEEEE;
        margin-bottom: 0px
      }
    }
    .dialog-footer {
      padding-bottom: 20px;
      border-top: 1px solid #f7f7f7;
      padding-top: 20px;
      display: flex;
      justify-content: center;
    }
  }
}
.el-message-box__wrapper {
  .el-message-box {
    padding-bottom: 20px;
    .el-message-box__header {
      padding: 12px 16px;
      border-bottom: 1px solid #eee;
      .el-message-box__title {
        color: #333333;
        line-height: 24px;
        font-size: 16px;
        font-family: 'PingFang SC-Regular';
        font-weight: 400;
      }
      .el-message-box__headerbtn {
        right: 30px;
        top: 20px;
      }
    }
    .el-message-box__content {
      padding: 25px 30px;
      border-bottom: 1px solid #eee;
    }
    .el-message-box__input {
      padding-top: 0px;
      height: 32px;
      .el-input {
        width: 100%;
      }
    }
    .el-message-box__btns {
      padding-top: 20px;
      padding-right: 30px;
      text-align: center;
      .el-button {
        font-size: 14px;
        font-family: 'PingFang SC-Regular';
        font-weight: 400;
        min-width: 60px;
      }
      .btn-blue {
        border: 1px solid #2E68EA;
        background: #2E68EA;
        color: white;
      }
      .btn-white {
        border: 1px solid #2E68EA;
        background: white;
        color: #2E68EA;
      }
    }
  }
}
</style>
